import { render, staticRenderFns } from "./BlackjackTable.vue?vue&type=template&id=65b71b96&scoped=true"
import script from "./BlackjackTable.vue?vue&type=script&lang=js"
export * from "./BlackjackTable.vue?vue&type=script&lang=js"
import style0 from "./BlackjackTable.vue?vue&type=style&index=0&id=65b71b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b71b96",
  null
  
)

export default component.exports